import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["field", "flag", "trigger"]

  enable() {
    this.fieldTargets.forEach((field) => {
      field.removeAttribute("readonly")
      field.removeAttribute("disabled")
    })
    this.fieldTargets[0]?.focus()
    this.flagTargets.forEach((flag) => (flag.value = "true"))
    this.triggerTargets.forEach((trigger) => (trigger.hidden = true))
  }
}
